import React from 'react';
import Header from './Header';
import Navigation from './Navigation';
import DarkModeToggle from './DarkModeToggle';
import { useHeaderHeight } from '../hooks/useHeaderHeight';
import { useCollapsibleHeader } from '../hooks/useCollapsibleHeader';

const HeaderContainer: React.FC = () => {
  const headerRef = useHeaderHeight();
  useCollapsibleHeader(headerRef);

  return (
    <div ref={headerRef} className="header-container">
      <div className="header-bar">
        <Header />
        <Navigation />
        <div className="header-bar-actions">
          <DarkModeToggle />
        </div>
      </div>
    </div>
  );
};

export default HeaderContainer;
